/**
 * 017: structure copied from
 * vendor/isomorphic/apps/isomorphic/src/app/shared/logistics/shipment/list/filters.tsx — its
 * `FilterElements`: one `StatusField` per filter. Same shape as `customers/filters.tsx`: the control
 * writes the route's `role` search param and the loader refetches. The search box (`q`) and the
 * status dropdown are the toolbar's own, in List.tsx.
 *
 * The roles offered are the API's (`GET /me/grantable-roles`), never a hard-coded list (rule 3).
 */
import { useNavigate } from "react-router-dom";
import { StatusField } from "@steelyard/theme";
import { FILTER_LABEL } from "../../components/table/toolbar";
import { roleName } from "../../lib/format";
import { userStatusLabel } from "../../lib/services/identity";

/** `AccountStatus.cs`'s members by their wire name; `pending` reads as "Invited", as on the rows. */
export const USER_STATUSES = ["active", "pending", "deactivated", "erased"].map((value) => {
  const key = userStatusLabel(value);
  return { value, key, label: key.charAt(0).toUpperCase() + key.slice(1) };
});

export function Filters({
  role,
  roles,
  query,
}: {
  role?: string;
  roles: string[];
  query: (over: Record<string, string | undefined>) => string;
}) {
  const navigate = useNavigate();
  const roleOptions = roles.map((value) => ({ value, label: roleName(value) }));

  // A filter change means a different result set, so it resets the page.
  const apply = (next: string | undefined) => navigate(query({ page: undefined, role: next }));

  return (
    <StatusField
      options={roleOptions}
      value={roleOptions.find((option) => option.value === role) ?? null}
      onChange={(option: { value: string } | null) => apply(option?.value)}
      clearable
      onClear={() => apply(undefined)}
      placeholder="Any role"
      label="Role"
      labelClassName={FILTER_LABEL}
      dropdownClassName="!z-10 h-auto"
      className="w-full @5xl:w-52"
    />
  );
}
